import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const NavbarButton = ({className, glyph, htmlId, onClick, text}) => {
   
    const buttonClassValues = classNames(
        "btn navbar-btn menu-button",
        className
    );

    const spanClassValues = classNames(
        "glyphicon",
        glyph,
        "menu-btn-icon"
    );

    return(
        <button
            className={buttonClassValues}
            id={htmlId}
            name={htmlId}
            onClick={onClick}
            title={text}
            type="button" >
            <div className="menu-button-content col-xs-12 hidden-sm hidden-md hidden-lg visible-xs" >
                <span className={spanClassValues}/>
                {text}
            </div>
            <div className="menu-button-content col-sm-12 hidden-xs hidden-md hidden-lg visible-sm" >
                <span className={spanClassValues} />
            </div>
            <div className="menu-button-content col-md-2 hidden-xs hidden-sm visible-md visible-lg">
                <span className={spanClassValues} />
            </div>
            {text && text.length > 0 &&
            <div className="menu-button-content col-md-10 hidden-xs hidden-sm visible-md visible-lg">
                {text}
            </div>
            }
        </button>
    );
};

NavbarButton.propTypes = {
    className: PropTypes.string,
    glyph: PropTypes.string,
    htmlId: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string
};

export default NavbarButton;


// WEBPACK FOOTER //
// ./src/components/TopMenu/NavbarButton.js